var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIconSubway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xA7\x80\xED\x95\x98\xEC\xB2\xA0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57567 4.16602H14.423C15.2016 4.16602 15.8327 4.79714 15.8327 5.57567V14.423C15.8327 15.2016 15.2016 15.8327 14.423 15.8327H5.57567C4.79714 15.8327 4.16602 15.2016 4.16602 14.423V5.57567C4.16602 4.79714 4.79714 4.16602 5.57567 4.16602ZM8.12243 6.44727H6.05078V13.5501H7.67851V9.251H7.74081L9.39969 13.3242C9.44642 13.441 9.54767 13.5111 9.67228 13.5111H10.3265C10.4433 13.5111 10.5523 13.4332 10.5991 13.3242L12.2579 9.26658H12.3203V13.5501H13.948V6.44727H11.8763L10.0461 10.9177H9.96044L8.12243 6.44727Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIconSubway);
export default __webpack_public_path__ + "static/media/mobile-icon-subway.3f73b6c93c91c782e94c59c2b41f0ad6.svg";
export { ForwardRef as ReactComponent };